import type { MessageSchema } from '@/translations';

const messages: MessageSchema = {
	a_few_more_details: 'Einige weitere Details',
	accept_mailinglist_sentence:
		'Ja, ich möchte als Erstes über Angebote und Neuigkeiten von Thermen {resort} informiert werden',
	accept_retreats_mailinglist_sentence:
		'Ich melde mich für die E-Mails von Retreats mit Neuigkeiten und persönlichen Angeboten an',
	accept_terms_sentence: 'Hiermit bestätige ich, den folgenden Bedingungen zuzustimmen: {terms_list}',
	accept_thermenfans_sentence:
		'Ich melde mich für das {link} an und profitiere daher von exklusiven Vorteilen wie: Angeboten, personalisierten Rabattgutscheinen, netten Geschenken und exklusivem Zugang zu Veranstaltungen',
	add_one: 'Hinzufügen',
	all_choices: 'Alle Auswahlen',
	amount_of_rooms: '{n} Zimmer | {n} Zimmer',
	an_email_will_be_sent_to_your_email_if_you_press_reset_password_this_email_will_contain_a_link_to_request_a_new_password:
		'Eine E-Mail wird an Ihre E-Mail-Adresse gesendet, wenn Sie auf "Passwort zurücksetzen" klicken. In dieser E-Mail befindet sich ein Link, um ein neues Passwort anzufordern.',
	are_you_coming_together_but_still_want_to_enjoy_your_own_room:
		'Kommen Sie zusammen, möchten aber dennoch ein eigenes Zimmer genießen? Kein Problem. Geben Sie einfach bei der Buchung Ihre Präferenz an, und wir kümmern uns darum, dass alles nach Ihren Wünschen arrangiert wird. So kann jeder seinen ultimativen Moment der Entspannung erleben.',
	are_you_sure_you_want_to_reset_your_password: 'Sind Sie sicher, dass Sie Ihr Passwort zurücksetzen möchten?',
	arrangement_badge: 'Arrangement',
	arrangement_choice_nr: 'Arrangement-Auswahl {n}',
	arrangement_choices: 'Arrangement @:choices',
	arrival: 'Ankunft',
	arrival_badge: 'Ankunft',
	arrival_night_subtitle: 'Alle Vorteile Ihres Arrangements',
	arrival_or_departure_day: 'An-/Abreisetag',
	arrival_and_departure_time_explanation:
		'Für einen entspannten Besuch bitten wir dich, zu den Zeiten deiner Reservierung anzukommen und abzureisen. So halten wir gemeinsam ein angenehmes Gleichgewicht bei der Anzahl der Gäste, die bei uns ein- und auschecken.',
	choose_arrival_and_departure_time: 'Wähle deine voraussichtliche Ankunfts- und Abreisezeit',
	belgium: 'Belgien',
	business_name: 'Name der Firma',
	cancellation_policy: 'Stornierungsbedingungen',
	cancellation_guarantee_title: 'Stornierungsgarantie',
	cancellation_guarantee_description:
		'Vermeiden Sie unnötige Kosten und schließen Sie für nur {price} pro Person eine flexible Stornierungsgarantie ab.',
	cancellation_guarantee_checkbox_label:
		'Ja, ich möchte gerne eine Stornierungsgarantie für {price} pro Person abschließen',
	cancellation_guarantee_subtitle:
		'Mit dieser Garantie können Sie Ihre Reservierung am Anreisetag bis 10:00 Uhr kostenlos stornieren oder umbuchen.',
	cancellation_guarantee_benefit_deadline: 'Bis 10:00 Uhr am Anreisetag kostenlos stornieren oder umbuchen.',
	cancellation_guarantee_benefit_reschedule:
		'Eine Umbuchung auf ein anderes Datum ist möglich. Gegebenenfalls wird ein Aufpreis für die Preisdifferenz berechnet.',
	cancellation_guarantee_benefit_any_reason:
		'Sie können Ihren Aufenthalt stornieren oder umbuchen, unabhängig vom Grund.',
	cancellation_guarantee_online_only:
		'Diese Garantie kann ausschließlich während einer Online-Reservierung hinzugefügt werden.',
	change_value_of_type_to_number: 'Ändere den Wert von {type} zu {number}',
	choices: 'Auswahl | Auswahlen',
	choose_arrangement:
		'Machen Sie Ihr Arrangement wirklich zu Ihrem eigenen. Wählen Sie aus den folgenden Optionen Ihren Favoriten für Ihren Wellness-Tag aus.',
	choose_your_arrival_and_departure_day_in_the_calendar: 'Wählen Sie Ihren Ankunfts- und Abreisetag im Kalender',
	city: 'Stadt',
	close: 'Schließen',
	comments_or_extra_information: 'Kommentare / zusätzliche Informationen',
	continue_reservation: 'Weiter',
	country: 'Land',
	customer_page_into_sentence:
		'Wir benötigen etwas mehr Informationen von Ihnen. Wirklich nur ein bisschen. Und wir behalten Ihre Daten natürlich für uns. Versprochen.',
	date_of_birth: 'Geburtsdatum',
	day: 'Tag',
	departure: 'Abfahrt',
	departure_badge: 'Abfahrt',
	departure_day_subtitle: 'Inkl. Frühstück und Zutritt zur Therme',
	edit: 'Bearbeiten',
	email_address: 'E-Mail-Adresse',
	estimated_time_of_arrival: 'Ankunftszeit',
	estimated_time_of_departure: 'Abfahrtszeit',
	finish_it_or_start_over: 'Möchtest du sie abschließen oder neu beginnen?',
	finish_reservation: 'Reservierung abschließen',
	new_reservation: 'Neue Reservierung',
	retreat_program_times:
		'Sie sind herzlich willkommen ab {start_time} Uhr am {arrival_date}. Das Programm endet gegen {end_time} Uhr am {departure_date}, danach sind Sie herzlich willkommen im Wellnessbereich.',
	evening: 'Abend',
	extra_charge: 'Aufpreis',
	extra_night_breakdown_title: 'Preisaufbau',
	extra_night_info_text:
		'Beim Einchecken erfahren Sie, wann Ihre Aktivitäten (zum Beispiel eine Behandlung oder ein Abendessen) geplant sind. Diese finden meistens am Anreisetag und/oder am zweiten Tag statt.\n\nBleiben Sie mehrere Nächte? Dann profitieren Sie von einem besonders günstigen Tarif pro Nacht.',
	extra_night_subtitle: 'Inkl. Frühstück und Zutritt zur Therme',
	filter: 'filtern',
	first_name: 'Vorname',
	fold: 'Einklappen',
	for_who: 'Für wen?',
	forgot_your_password_no_problem: 'Passwort vergessen? Kein Problem.',
	from_price: 'ab',
	germany: 'Deutschland',
	go_to_the_website: 'Zur Website gehen',
	hide: 'Verbergen',
	hide_all_single_rooms: 'Alle Einzelzimmer ausblenden',
	hotel_room_availability: 'Noch {number} verfügbar',
	hotel_room_choice: 'Wähle dein Hotelzimmer',
	hotel_room_type_1: 'EINZELZIMMER',
	hotel_room_type_2: 'DOPPELZIMMER',
	hotel_room_type_3: 'DREIBETTZIMMER',
	hotel_room_type_4: 'VIERBETTZIMMER',
	view_details: 'Details anzeigen',
	hide_details: 'Details ausblenden',
	select_room: 'ZIMMER WÄHLEN',
	select_this_room: 'DIESES ZIMMER WÄHLEN',
	choose_your_hotel_room: 'Wähle dein Hotelzimmer',
	what_this_room_offers: 'WAS DIESES ZIMMER BIETET',
	all: 'Alle',
	change: 'Ändern',
	booking_summary:
		'Du möchtest für {persons} buchen und möchtest {rooms} mit Anreisedatum {arrival} und Abreisedatum {departure}.',
	room: 'Zimmer',
	rooms: 'Zimmer',
	hotel_rooms: 'Hotelzimmer',
	hotel_rooms_page_into_sentence: 'Kommst du, um bei uns zu übernachten?',
	house_number: 'Hausnummer',
	house_number_addition: 'Zusatz',
	house_rules: 'Hausregeln',
	make_your_choice: 'Treffen Sie Ihre Wahl',
	duration: 'Dauer',
	how_would_you_like_to_book_your_relaxing_moment: 'Wie möchten Sie Ihren Entspannungsmoment buchen?',
	i_have_a_my_thermen_account: 'Ich habe ein Thermen Resorts-Konto',
	i_want_to_create_a_my_thermen_account: 'Ich möchte ein Thermen Resorts-Konto erstellen',
	i_want_to_create_a_my_thermen_account_tooltip:
		'Schnellere Reservierungen und nie wieder deine Daten eingeben müssen. Ein Thermen Resorts Konto bietet dir mehr. Mehr Bequemlichkeit und mehr Vorteile. Beachte! Dein Konto wird aktiviert, indem du auf den Link in der Verifizierungs-E-Mail klickst.',
	i_want_to_make_a_reservation_without_an_account: 'Ich möchte eine Reservierung ohne Konto vornehmen',
	i_would_like_to_create_an_account: 'Ich möchte ein Konto erstellen',
	invoice_comment_placeholder: 'Kommentare/Details (z. B. Kaufnummer)',
	invoice_information: 'Rechnungsinformationen des Arbeitgebers',
	last_name: 'Nachname',
	login: 'Einloggen',
	logout: 'Abmelden',
	lunch_and_diner: 'Mittagessen und Abendessen',
	lunch_and_diner_page_into_sentence:
		'Ihr Wellness-Tag noch vollständiger und noch schöner? Entdecken Sie unsere Aufgüsse, Rituale, Meditationen und andere angenehme Entspannungsmomente... Unser Tipp? Wählen Sie, was Sie glücklich macht!',
	make_it_your_day: 'Machen Sie es zu Ihrem Tag!',
	mobile_phone_number: 'Handynummer',
	month: 'Monat',
	more_information: 'Weitere Informationen',
	morning: 'Morgen',
	mr: 'Herr',
	ms: 'Frau',
	my_preferences_for_a_room_are: 'Meine Präferenzen für ein Zimmer sind',
	name_infix: 'Zwischenname',
	navigate_to_name_in_the_calendar: 'Navigiere zu {name} im Kalender.',
	need_help_with_your_room_choices: 'Benötigen Sie Hilfe bei der Auswahl Ihres Zimmers?',
	next: 'Weiter',
	next_choices: 'Nächste Möglichkeiten',
	next_image: 'Nächstes Bild',
	nights_count: '{n} Nacht | {n} Nächte',
	nth_night: '{n}. Nacht',
	no_rooms_available_selected_date_filters:
		'Für das aktuell ausgewählte Datum sind in Kombination mit den ausgewählten Filtern keine Zimmer verfügbar.',
	notice_chosen_date_or_time_is_unavailable: 'Das gewählte Datum und/oder Uhrzeit ist nicht verfügbar!',
	notice_there_are_no_hotel_rooms_unavailable:
		'Keine Zimmer verfügbar am gewählten Datum in Kombination mit den ausgewählten Filtern.',
	notice_this_hotel_room_is_unavailable: 'Dieses Zimmer ist an dem gewählten Tag nicht mehr verfügbar!',
	number_of_persons: '{n} Person | {n} Personen',
	or_stay_with_us_for_a_good_night_sleep: 'Oder bleiben Sie bei uns für eine gute Nachtruhe?',
	other: 'Sonstiges',
	one_or_more_choices_are_no_longer_available:
		'Eine oder mehrere Optionen deiner Reservierung sind nicht mehr verfügbar. Passe sie an, um fortzufahren.',
	password: 'Passwort',
	password_confirmation: 'Passwort wiederholen',
	pay: 'Bezahlen',
	per_night: 'pro Nacht',
	per_person_including_breakfast_starting_from: 'p.p. inklusive Frühstück ab',
	per_person_per_night: 'p.P.p.N.',
	per_person_short: 'p.P.',
	persons: 'Person | Personen',
	persons_count: 'Anzahl der Personen',
	persons_short: 'Pers.',
	price_included: 'Inklusive',
	previous: 'Zurück',
	previous_choices: 'Vorherige Möglichkeiten',
	previous_image: 'Vorheriges Bild',
	prices_are_in_euro: 'Preise in € @:per_person_short',
	prices_are_in_euro_per_night: 'Preise in € @:per_person_per_night',
	privacy_policy: 'Datenschutzerklärung',
	receive_a_present_on_your_birthday: 'Ein Geschenk zum Geburtstag erhalten?',
	reload: 'Neu laden',
	request_your_new_password_here: 'Fordere hier dein neues Passwort an.',
	read_only_availability_notice:
		'Dies ist eine Testumgebung, um die Verfügbarkeit anzusehen. Kaufen Sie zuerst Ihr Ticket und nehmen Sie anschließend über unsere Website Ihre endgültige Reservierung vor.',
	reset: 'Zurücksetzen',
	reset_filters: 'Filter zurücksetzen',
	reset_password: 'Passwort zurücksetzen',
	rituals_extras: 'Extras für deinen Saunatag',
	rituals_extras_page_into_sentence:
		'Möchtest du deinen Wellness-Tag noch vollständiger und angenehmer gestalten? Entdecke unsere Aufgüsse, Rituale, Meditationen und andere angenehme Entspannungsmomente... Unser Tipp? Wähle vor allem das, was dich glücklich macht!',
	rooms_count: 'Anzahl der Zimmer',
	select: 'Auswählen',
	skip_this_step: 'Diesen Schritt überspringen',
	select_all: 'Alles auswählen',
	select_for_all: 'Für alle auswählen',
	selected: 'Ausgewählt',
	send_invoice: 'Mein Arbeitgeber bezahlt die Rechnung.',
	share_a_room_together_select_one_of_the_available_room_options_below:
		'Teile ein Zimmer zusammen, wähle eine der verfügbaren Zimmeroptionen unten aus.',
	show_all_single_rooms: 'Alle Einzelzimmer anzeigen',
	something_went_wrong_while_retrieving_your_data: 'Beim Abrufen deiner Daten ist ein Fehler aufgetreten.',
	start_a_new_reservation: 'Neu beginnen',
	steps: {
		choices: 'Deine Auswahl',
		complete: 'Abschluss',
		customer_details: 'Kundendaten',
		reservation: 'Reservierung',
	},
	street: 'Straße',
	swimwear_day: 'Badekleidungstag',
	filter_swimwear_days: 'Nach Badekleidungstagen filtern',
	swimwear_day_tooltip_sentence:
		'Die blau markierten Tage im Kalender sind Badekleidungstage. An diesen Tagen ist das Tragen von Badekleidung obligatorisch.',
	special_day: 'Besonderer Tag',
	terms_and_conditions: 'Allgemeine Geschäftsbedingungen',
	terms_item_1:
		'Meine Ankunfts- und Abreisezeit (damit eventuelle Behandlungen innerhalb einer halben Stunde nach der angegebenen Ankunftszeit und vor der angegebenen Abreisezeit stattfinden können)',
	terms_item_2: 'Die {house_rules} gelesen zu haben',
	terms_item_3: 'Die {terms_and_conditions}, {cancellation_policy} und {privacy_policy}',
	the_netherlands: 'Niederlande',
	the_price_of_your_reservation_has_changed:
		'Achtung: Der Preis deiner Reservierung hat sich geändert. Vorher {previous}, jetzt {current}.',
	there_are_no_selectable_products_available_at_the_selected_time:
		'Für das gewählte Datum sind derzeit keine Optionen verfügbar, bitte versuchen Sie es zu einem anderen Zeitpunkt.',
	thermenfans_program: 'Thermenfans-Programm',
	total: 'Gesamt',
	treatment_page_into_sentence:
		'Dein Tag bei uns kann noch vollständiger sein. Eine Massage? Eine Behandlung...? Unser Tipp: Wähle das, was dich glücklich macht, das ist immer die beste Wahl.',
	unavailable: 'Nicht verfügbar',
	unfortunately_an_error_has_occurred_please_try_again_shortly:
		'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es in Kürze erneut.',
	unfortunately_there_are_no_available_choices_on_this_date_please_select_another_date:
		'Leider sind an diesem Datum keine Optionen verfügbar. Bitte wählen Sie ein anderes Datum aus.',
	plan_your: 'Plane deinen {product}',
	view: 'Betrachten',
	view_reservation: 'Reservierung hier ansehen',
	we_put_together_the_available_options_for_you: 'Wir stellen die verfügbaren Optionen für Sie zusammen...',
	what_would_you_like_to_book: 'Was möchtest du buchen?',
	when_are_you_coming_to_relax: 'Wann kommst du zum Entspannen?',
	when_resetting_previously_entered_data_will_be_lost: 'Beim Zurücksetzen gehen zuvor eingegebene Daten verloren.',
	which_type_of_treatment_suits_you: 'Welche Behandlung passt zu dir:',
	year: 'Jahr',
	you_have: 'Du hast',
	you_have_an_unfinished_reservation: 'Du hast eine unvollendete Reservierung',
	you_have_number_of_choices: 'Sie haben <strong>{n}</strong> Wahl|Sie haben <strong>{n}</strong> Möglichkeiten',
	you_want_to_book_with:
		'Du möchtest mit <strong>{persons}</strong> buchen und möchtest <strong>{rooms}</strong> mit Ankunftsdatum {arrival_date} und Abreisedatum {departure_date}.',
	your_experience: 'Dies erwartet dich:',
	your_first_step_to_great_enjoyment: 'Dein erster Schritt zum großen Genuss!',
	your_reservation_has_changed: 'Deine Reservierung hat sich geändert',
	zip_code: 'Postleitzahl',
};

export default messages;
